import { useState } from "react"
import { useTranslation } from "react-i18next"
import { AUTH_CODE_TYPE_ENUM } from "@antipartido-inc/contracts-ifaces"
import { Button, InfoCard, TextField } from "@cividao/components"
import styles from "./index.module.css"
import { DomainError } from "../../../../domain/_kernel/DomainError"

interface CredentialsStepProps {
  onComplete: (email: string) => void
}

export function CredentialsStep({ onComplete }: CredentialsStepProps) {
  const { t } = useTranslation("auth")
  const [email, setEmail] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("")

  const isFormValid = !!email

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const handleSubmit = () => {
    if (!isFormValid) return

    setIsLoading(true)
    setError("")

    window.domain.SendAuthCodeAuthUseCase.execute({
      email,
      type: AUTH_CODE_TYPE_ENUM.LOGIN,
    })
      .then(() => {
        onComplete(email)
      })
      .catch((err: unknown) => {
        const errorCode = err instanceof DomainError ? err.code : "unknown"
        const errorMessage = String(t(`errors.${errorCode}`, { defaultValue: t("errors.unknown") }))
        setError(errorMessage)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <div className={styles.form}>
      <TextField
        label={t("shared.email.label")}
        type="email"
        value={email}
        onChange={handleEmailChange}
        placeholder={t("shared.email.placeholder")}
      />

      {error && <InfoCard dismissable={false} variant="warning" title={t("shared.verify.error.title")} message={error} />}

      <Button onClick={handleSubmit} isDisabled={!isFormValid} isLoading={isLoading} isFull>
        {t("shared.button")}
      </Button>
    </div>
  )
}
